export function toScheduledFromIsoFromPickerDate(date: Date): string {
  const localStart = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    0,
    0,
    0,
    0
  );
  return localStart.toISOString();
}
